import styles from "./Header.module.scss";
import logo from "../../../img/header_icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "../../../components/button/IconButton";
import { TopbarUserDropdown } from "./TopbarUserDropdown";
import ToolTipTitleBodyIcon from "../../../components/ToolTipTitleBody";
import React from "react";
import AlertPopUp from "../../../components/AlertPopUp";
import ActionDropdown from "../../../components/dropdown/ActionDropdown";
import { useModal } from "../../../components/Modal";
import TrainingVideoLibraryModal from "./TrainingVideoLibraryModal";
import axiosInstance from "../../../api";

function getSafeApiUrl(path: string): string | null {
  const apiUrl =
    axiosInstance.defaults.baseURL ||
    localStorage.getItem("apiUrl") ||
    window.location.origin;
  if (!apiUrl) return null;
  try {
    const parsed = new URL(apiUrl, window.location.origin);
    if (parsed.protocol !== "https:" && parsed.protocol !== "http:")
      return null;
    return parsed.origin + parsed.pathname.replace(/\/+$/, "") + path;
  } catch {
    return null;
  }
}

type HelpMenuItem =
  | { label: string; path: string; action?: never }
  | { label: string; action: () => void; path?: never };

const Header = ({ showOnlyLogo = false }) => {
  const [showAlert, setShowAlert] = React.useState(false);
  const openTrainingVideoLibrary = useModal(
    <TrainingVideoLibraryModal />,
    "trainingVideoLibraryModal",
  );

  const openHelpDocument = (path: string) => {
    const url = getSafeApiUrl(path);
    if (url) {
      window.open(url, "_blank", "width=800,height=600");
    }
  };

  const helpMenuItems: HelpMenuItem[] = [
    { label: "FAQs", path: "/rest/user/help/document/faq" },
    { label: "Glossary", path: "/rest/user/help/document/glossary" },
    {
      label: "Product Guide",
      path: "/rest/user/help/document/productGuide",
    },
    {
      label: "Training Videos",
      action: () => openTrainingVideoLibrary({ closeOnClickBackdrop: true }),
    },
  ];

  const openHelpMenuItem = (item: HelpMenuItem) => {
    if (item.action) {
      item.action();
    } else {
      openHelpDocument(item.path);
    }
  };

  return (
    <header className={styles.header} role={"banner"}>
      <div style={{ display: "flex", alignItems: "center", gap: "13px" }}>
        <img className={styles.headerLogo} src={logo} alt="" />
        <div className={styles.divider} />
        <span className={styles.productName}>Commercial Vehicle Insights</span>
      </div>

      {showOnlyLogo ? null : (
        <div className={styles.tabs}>
          <ActionDropdown
            button={
              <IconButton theme="dark" isHeader={true}>
                <FontAwesomeIcon icon={faCircleInfo} />
              </IconButton>
            }
            menuClass={styles.helpMenuContainer}
            pointerAlign="right"
          >
            <aside className={`popup ${styles.helpMenuPopup}`}>
              <div className="popup-content">
                {helpMenuItems.map((item) => (
                  <div
                    key={item.label}
                    className="menu-option"
                    role="menuitem"
                    tabIndex={0}
                    onClick={() => openHelpMenuItem(item)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openHelpMenuItem(item);
                      }
                    }}
                  >
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
            </aside>
          </ActionDropdown>
          {/* <IconButton
            theme="dark"
            isHeader={true}
            onClick={() => {
              const url = getSafeApiUrl("/rest/user/help/document/faq");
              if (url) {
                window.open(url, "_blank", "width=800,height=600");
              }
            }}
          >
            <ToolTipTitleBodyIcon
              icon={faCircleQuestion}
              iconPositionCenter={true}
              titleMessage="FAQs"
              bodyMessage="Frequently Asked Questions"
              position={"bottom"}
            />
          </IconButton> */}
          <IconButton
            theme="dark"
            isHeader={true}
            onClick={() => {
              setShowAlert(true);
            }}
          >
            <ToolTipTitleBodyIcon
              icon={faPhone}
              iconPositionCenter={true}
              titleMessage="Contact Us"
              bodyMessage="Product Help Desk"
              position={"bottom"}
            />
          </IconButton>
          <TopbarUserDropdown />
        </div>
      )}

      {showAlert && (
        <AlertPopUp
          width={"520px"}
          header="Contact Us"
          closeAction={() => setShowAlert(false)}
        >
          <section className={styles.contactHelpDesk}>
            <h3 className={styles.contactTitle}>Global Product Help Desk</h3>

            <div className={styles.contactGrid}>
              <div className={styles.contactItem}>
                <span className={styles.contactLabel}>Phone</span>
                <a className={styles.contactValue} href="tel:+18008765526">
                  1-800-876-5526
                </a>
              </div>

              <div className={styles.contactItem}>
                <span className={styles.contactLabel}>Email</span>
                <a
                  className={styles.contactValue}
                  href="mailto:Product_Helpdesk@mobilityglobal.com"
                >
                  Product_Helpdesk@mobilityglobal.com
                </a>
              </div>
            </div>
          </section>
        </AlertPopUp>
      )}
    </header>
  );
};

export default Header;
